import { render } from "./SVGContent.vue?vue&type=template&id=e26c313e"
import script from "./SVGContent.vue?vue&type=script&lang=ts"
export * from "./SVGContent.vue?vue&type=script&lang=ts"

import "./SVGContent.vue?vue&type=style&index=0&id=e26c313e&lang=css"
script.render = render

export default script